import React, { Suspense, useState } from "react";
import TopNavbarAdmin from "./TopNavbarAdmin";
import SideNavbarAdmin from "./SideNavbarAdmin";
import Footer from "./Footer";
import "../Style/App.css";

const Main = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  return (
    <div className="main-layout">
      <Suspense>
        <TopNavbarAdmin toggleSidebar={toggleSidebar} collapsed={collapsed} />
      </Suspense>

      <Suspense>
        <SideNavbarAdmin collapsed={collapsed} />
      </Suspense>

      <div
        style={{
          flex: 1,
          marginLeft: collapsed ? "80px" : "250px",
          transition: "margin-left 0.3s",
          padding: "0px",
          paddingBottom: "60px",
        }}
      >
        {children}
      </div>

      <Suspense>
        <Footer
          style={{
            position: "fixed",
            bottom: 0,
            left: collapsed ? "80px" : "250px", 
            right: 0,
            height: "60px",
            transition: "left 0.3s",
            zIndex: 1020,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            padding: ' 0 20px'
          }}
        />
      </Suspense>
    </div>
  );
};

export default Main;